import { render, staticRenderFns } from "./rank-item.vue?vue&type=template&id=b0a5da8e&"
import script from "./rank-item.vue?vue&type=script&lang=js&"
export * from "./rank-item.vue?vue&type=script&lang=js&"
import style0 from "./rank-item.vue?vue&type=style&index=0&id=b0a5da8e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports